import { useCallback, useState } from "react";
import { toast } from "react-toastify";
import { swingLibraryService } from "../../../../../services/swingLibrary";

export const usePdfData = () => {
  const [actionSdkResponse, setActionSdkResponse] = useState(null);
  const [firstPageReportData, setFirstPageReportData] = useState(null);
  const [hasFetchingFailed, setHasFetchingFailed] = useState(false);

  const fetchDataForGeneration = useCallback(
    async (
      videoIdsForRequest,
      golfClubForRequest,
      genderForRequest,
      heightForRequest
    ) => {
      try {
        const data = await swingLibraryService.preparePdfReport({
          gender: genderForRequest,
          golfClub: golfClubForRequest,
          height: heightForRequest,
          videoIds: videoIdsForRequest,
        });

        setActionSdkResponse(data);
        setFirstPageReportData({
          clubSpeed: data.speedPercentile.clubHeadSpeedAvgIndicatorValue,
          consistencyScore: data.consistencyScore.consistencyScore,
          descriptionSections: data.reportSection,
          efficiencyScore: data.efficiencyScore.efficiencyScore,
          overallScore: data.overallScore,
          speedScore: data.speedPercentile.clubHeadSpeedPercentileScore,
          swingType: data.swingType,
        });
        return true;
      } catch (err) {
        const errorMessage =
          err?.response?.data?.message ||
          err?.message ||
          "An unexpected error occurred. Please try again later.";
        console.error(err);
        toast.error(errorMessage);
        setHasFetchingFailed(true);
        return false;
      }
    },
    []
  );

  return {
    actionSdkResponse,
    fetchDataForGeneration,
    firstPageReportData,
    hasFetchingFailed,
  };
};
